import React, { Component } from 'react';
import { Route, Switch, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import classes from './App.css';
import StoreList from './containers/StoreList/StoreList';
import People from './containers/People/People';
import DateAndTime from './containers/DateTime/DateAndTime';
import Menu from './containers/Menu/Menu';
import Header from './components/UI/Header/Header';
import Test from './containers/TestContainer/TestContainer';
import { apiLogin } from './api/login';
import { bookingConfirmationOpen } from './store/actions/bookingConfirmation';
import { LogoLoader } from './components/UI/Loader/LogoLoader';
import { settingsSetLanguage } from './store/actions/settings';
import { PersonalDataContainer } from './containers/PersonalDataForm/PersonalData';
import { EditBooking } from './containers/EditBooking';
import { editBookingSetValues } from './store/actions/editBooking';
import { DeleteBooking } from './containers/EditBooking/DeleteBooking';
import { ROUTES } from './constants';
import { preselectedStoreStartRequests } from './store/actions/preselectedStore';

class App extends Component {
  state = {
    stores: [],
    isRequestingToken: true
  }

  async componentDidMount() {
    if (window.location.pathname !== '/') {
      return window.location.href = '/';
    }
    try {
      await this.props.setLanguage();
      await apiLogin();

      // Parse the url for edit booking
      let search = this.props.location.search;
      if (search && search.length > 0) {

        let parsedSearch = search.substring(1);
        parsedSearch = parsedSearch.split('&').reduce((prev, s) => {
          const values = s.split('=');
          return { ...prev, [values[0]]: values[1] }
        }, {});

        if (parsedSearch.booking === 'edit' && parsedSearch.rest && parsedSearch.code) {
          this.props.editBookingSetValues({
            restaurantName: parsedSearch.rest,
            bookingCode: parsedSearch.code
          });
          this.props.history.push({
            pathname: '/modifica-prenotazione',
          });
        } else if (parsedSearch.country && parsedSearch.store) {
          this.props.preselectStore(parsedSearch.country, parsedSearch.store);
        }
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.setState({ isRequestingToken: false });
    }
  }

  render() {
    return (
      <div className={classes.App}>
        <Header />
        <div className={classes.Booking}>
          {this.state.isRequestingToken ?
            <LogoLoader />
            :
            <Switch>
              <Route path={ROUTES.countries} exact component={StoreList} />
              <Route path={ROUTES.people} component={People} />
              <Route path={ROUTES.date} component={DateAndTime} />
              <Route path={ROUTES.menu} component={Menu} />
              <Route path={ROUTES.personalData} component={PersonalDataContainer} />
              <Route path={ROUTES.changeBooking} component={EditBooking} />
              <Route patch={ROUTES.deleteBooking} component={DeleteBooking} />
              <Route path="/test" component={Test} />
              <Route path="*" exact component={StoreList} />
            </Switch>
          }
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => ({
  isBookingConfirmationOpen: state.bookingConfirmationReducer.isPopupOpen,
  isChangeStoreModalOpen: state.changeStoreModalReducer.isOpen,
  isModalChangeStoreLoading: state.changeStoreModalReducer.isLoadingNewStore || state.changeStoreModalReducer.isLoadingStores,
  stores: state.changeStoreModalReducer.availableStores,
  translations: state.settingsReducer.translations,
});


const mapDispatchToProps = dispatch => ({
  setConfirmationPopupOpen: isOpen => dispatch(bookingConfirmationOpen(isOpen)),
  setLanguage: () => dispatch(settingsSetLanguage()),
  editBookingSetValues: params => dispatch(editBookingSetValues(params)),
  preselectStore: (country, storeId) => dispatch(preselectedStoreStartRequests(country, storeId)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));



// WEBPACK FOOTER //
// ./src/App.js